/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import SimpleReactValidator from "simple-react-validator";
import Cookies from "universal-cookie";
import { ADMIN_API, USER_API } from "../common/common";
import { formatTwoDecimal, getImageUrl, getLoginDeviceInfo, getSiteHeaderSchema, getSiteLogo, isCaptchaEnabled, Logout, readLoginFields, setAuthCookie } from "../common/Funcation";
// import { useCredentialAutofillLogin } from "../hooks/useCredentialAutofillLogin";
import {
  getTheme,
  styleObjectGetBG,
  styleObjectGetBGasColor,
  styleObjectGetBorderColor,
  styleObjectGetColor,
  styleObjectGetHeaderSchema,
  getMobileLoginButtonClassName,
  getMobileLoginButtonStyle,
  getHeaderAccountButtonStyle,
  getHeaderAccountButtonTextClass,
  getHeaderAccountButtonTextColor,
} from "../common/StyleSeter";
import { Helmet } from "react-helmet";

import Login from "../pages/Login";
import {
  getApi,
  getApiLink,
  notifyError,
  notifyMessage,
  postApi,
  sendEvent,
} from "../service";
import StakePopup from "./StakePopup";
import BetBox from "../pages/MultiMarket/BetBox";
import transparent from "../assets/images/transparent.gif";
import yelloImage from "../assets/images/s-yellow.svg";
import redSetingImage from "../assets/images/s-red.svg";
import whiteSetingImage from "../assets/images/s-white.svg";
import pinkSetingImage from "../assets/images/s-pink.svg";
import { isMobile } from "react-device-detect";
import MobileFooter from "./mobileFooters";
import { ForuserPortal } from "./ZoomablePageContent";
import SignupButton from "./SignupButton";
import NewsLine from "./NewsLine";

const cookies = new Cookies();

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const homeData = useSelector((e: any) => e.homeData);
  const HeaderData = useSelector((e: any) => e.Header);
  const isAuthenticated = useSelector((e: any) => e.isAuthenticated?.isLogin);
  const marketListDetails = useSelector((e: any) => e.marketListDetails);
  const [searchEvent, setSearchEvent] = useState<any>({
    searchText: "",
    typing: false,
    typingTimeout: undefined,
  });
  const betHistoryShow = useSelector((e: any) => e.betHistoryShow);
  const betHistoryHistoryPushed = useRef(false);
  const [searchData, setSearchData] = useState<any>();
  const balanceData = useSelector((e: any) => e.balance);
  const exposureData = useSelector((e: any) => e.exposure);
  const DD = useSelector((e: any) => e.domainDetails);
  const [domainDetails, setDomainDetails] = useState(DD);
  const [headerOptions, setHeaderOptions] = useState(HeaderData);
  const [OpenModal, setOpenModal] = useState<boolean>(false);
  const [manageStack, setManageStack] = useState<any>();
  const matchCount = useSelector((e: any) => e.matchCount);
  const [formData, setFormData] = useState({
    user_name: "",
    password: "",
    validationCode: "",
  });
  const [headerOption, setHeaderOption] = useState([
    { name: "Home", hasAccess: true, link: "/", subOption: [] },
    { name: "InPlay ", hasAccess: true, link: "/in-play", subOption: [] },
    {
      name: "Multi Markets",
      hasAccess: true,
      link: "/multimarket",
      subOption: [],
    },
    { name: "Cricket", hasAccess: true, link: "/cricket", subOption: [] },
    { name: "Soccer", hasAccess: true, link: "/soccer", subOption: [] },
    { name: "Tennis", hasAccess: true, link: "/tennis", subOption: [] },
    { name: "E-Soccer", hasAccess: false, link: "/Esoccer", subOption: [] },
    { name: "basketBall", hasAccess: false, link: "/basketBall", subOption: [] },
    { name: "Casino", hasAccess: true, link: "", subOption: [] },
  ]);
  const [showPass, setShowPass] = useState(false);
  console.log({ matchCount })
  useEffect(() => {
    console.log("marketListDetails :: ", marketListDetails, homeData)
    if (marketListDetails?.data?.length > 0) {
      let HEADER_OPTIONS = [...headerOption];
      HEADER_OPTIONS.forEach((element: any) => {
        marketListDetails.data.forEach((item: any) => {
          if (item?.name === element?.name) {
            element.hasAccess = !item.isBlock;
          }
        });
        if (element?.name === "E-Soccer" && homeData?.eSoccer === true) {
          element.hasAccess = true;
        }
        if (element?.name === "basketBall" && homeData?.basketBall === true) {
          element.hasAccess = true;
        }
      });
      setHeaderOption([...HEADER_OPTIONS]);
    } else {
      let HEADER_OPTIONS = [...headerOption];
      HEADER_OPTIONS.forEach((element: any) => {
        if (element?.name === "E-Soccer" && homeData?.eSoccer === true) {
          element.hasAccess = true;
        }
        if (element?.name === "basketBall" && homeData?.basketBall === true) {
          element.hasAccess = true;
        }
      })
      setHeaderOption([...HEADER_OPTIONS]);
    }
    return () => { };
  }, [marketListDetails, homeData]);

  const [isLoadding, setIsLoadding] = useState(true);
  const [searchString, setSearchString] = useState("");
  const [oneClickActive, setOneClickActive] = useState(false);
  const [menuActive, setMenuActive] = useState(false);
  const [OpenSetting, setOpenSetting] = useState(false);
  const [, updateState] = React.useState({});
  const forceUpdate = React.useCallback(() => updateState({}), []);
  const [confirmationCode, setConfirmationCode] = useState(
    Math.floor(1000 + Math.random() * 9000)
  );
  const [isValidationWrong, setIsValidationWrong] = useState(false);
  const isCaptcha = isCaptchaEnabled(DD?.captchaFrontend);
  // const credentialAutofillRef = useCredentialAutofillLogin(!isCaptcha);
  const isSubmittingRef = useRef(false);

  const handelInputChange = (e: any) => {
    const { name, value } = e.target;
    setIsValidationWrong(false);
    setFormData({ ...formData, [name]: value });
  };
  const handelSubmit = async (e: any) => {
    e.preventDefault();
    if (isSubmittingRef.current) {
      return;
    }
    const { username, password } = readLoginFields(e, formData);
    if (username !== formData.user_name || password !== formData.password) {
      setFormData({ ...formData, user_name: username, password });
    }

    if (
      username &&
      password &&
      (confirmationCode === parseInt(formData.validationCode) || !isCaptcha)
    ) {
      setIsValidationWrong(false);
      isSubmittingRef.current = true;
      const deviceInfo = getLoginDeviceInfo();

      let data = {
        api: USER_API.LOGIN,
        value: {
          user_name: username,
          password,
          domain: window.location.hostname,
          systemDetail: deviceInfo.systemDetail,
          browser_detail: deviceInfo.browser_detail,
        },
      };
      setIsLoadding(true);
      await postApi(data)
        .then(function (loginData) {
          if (loginData) {
            // notifyMessage(loginData.data.message)

            let HeaderData = {
              ...loginData.data.data.roleAccess,
              user_name: loginData.data.data.user_name,
              remaining_balance: loginData.data.data?.balance,
              exposure: loginData.data.data?.exposure,
              ...loginData.data.data,
            };
            dispatch({ type: "HEADER_DETAILS", payload: HeaderData });
            setAuthCookie(loginData.data.data.token);
            dispatch({
              type: "AUTHENTICATION",
              payload: {
                isLogin: true,
                token: loginData.data.data.token,
                changePassword: loginData.data.data.newPassword,
              },
            });
            setOpenModal(false);
            if (loginData.data.data.newPassword) {
              navigate("/change/password");
            }
          }
        })
        .catch((err) => {
          setIsLoadding(false);
          notifyError(err?.response?.data?.message || "Login failed. Please try again.");
          setIsValidationWrong(false);
          setConfirmationCode(Math.floor(1000 + Math.random() * 9000));
          setFormData((current) => ({ ...current, validationCode: "" }));
        })
        .finally(() => {
          isSubmittingRef.current = false;
        });
    } else {
      Validator.current.showMessages();
      if (confirmationCode !== parseInt(formData.validationCode)) {
        setIsValidationWrong(true);
      }
      setConfirmationCode(Math.floor(1000 + Math.random() * 9000));
      forceUpdate();
    }
  };
  const Validator = useRef(
    new SimpleReactValidator({
      autoForceUpdate: this,
    })
  );

  const getBalance = async () => {
    let data = {
      api: USER_API.GET_PROFILE,
      // value: { user_name: formData.user_name, password: formData.password }
    };
    setIsLoadding(true);
    await getApi(data)
      .then(function (profileData) {
        if (profileData) {
          dispatch({
            type: "UPDATE_USER_BALANCE",
            payload: {
              balance: profileData?.data?.data?.balance,
              remaining_balance: profileData?.data?.data?.remaining_balance,
              exposure: profileData?.data?.data?.exposure,
            },
          });
          setIsLoadding(false);
        }
      })
      .catch((err) => {
        setIsLoadding(false);
        if (err?.response?.data?.statusCode === 401 || err?.response?.status === 401) {
          return;
        }
      });
  };

  useEffect(() => {
    if (balanceData !== "" && exposureData !== "") {
      setIsLoadding(false);
    }
  }, [balanceData, exposureData]);

  useEffect(() => {
    setHeaderOptions(HeaderData);
    return () => { };
  }, [HeaderData]);

  useEffect(() => {
    setDomainDetails(DD);
    return () => { };
  }, [DD]);

  useEffect(() => {
    const countTimer = setInterval(() => {
      if (typeof document !== "undefined" && document.visibilityState === "hidden") {
        return;
      }
      sendEvent("GET_LIVE_MATCH_COUNT", {});
    }, 10000);
    return () => {
      clearInterval(countTimer);
    };
  }, []);

  const HandleNavigation = (path: string) => {
    navigate(path);
  };

  const HandleLogOut = (e: any) => {
    e.preventDefault();
    Logout(e);
    dispatch({
      type: "AUTHENTICATION",
      payload: { isLogin: false, token: "", changePassword: false },
    });
    navigate("/");
  };

  const items = [
    { id: 0, name: "Cobol" },
    { id: 1, name: "JavaScript" },
    { id: 2, name: "Basic" },
    { id: 3, name: "PHP" },
    { id: 4, name: "Java" },
  ];

  const handleOnSearch = (e: string) => {
    // setSearchString(string);
  };

  const oneClick = () => {
    setOneClickActive(true);
  };
  const formatResult = () => {
    return (
      <>
        <span style={{ display: "block", textAlign: "left" }}>id: </span>
        <span style={{ display: "block", textAlign: "left" }}>name:</span>
      </>
    );
  };

  const getInPlayData = async (FILTER: string) => {
    // setIsLoading(true)

    let data = {
      api: USER_API.IN_PLAY,
      value: { filter: FILTER },
    };

    await postApi(data)
      .then(function (response) {
        if (FILTER === "play") {
          dispatch({
            type: "SET_IN_PLAY_DETAILS_IN_PLAY",
            payload: response.data.data,
          });
        } else if (FILTER === "today") {
          dispatch({
            type: "SET_IN_PLAY_DETAILS_TODAY",
            payload: response.data.data,
          });
        } else if (FILTER === "tomorrow") {
          dispatch({
            type: "SET_IN_PLAY_DETAILS_TOMORROW",
            payload: response.data.data,
          });
        } else {
          dispatch({ type: "SET_IN_PLAY_DETAILS", payload: undefined });
        }
      })
      .catch((err) => {
        console.log(err);
        if (err.response?.data?.statusCode === 401) {
          Logout();
          // navigate('/login')
        }
      });
  };

  useEffect(() => {
    setTimeout(() => {
      sendEvent("GET_SPORTS", { type: "cricket" });
      sendEvent("GET_SPORTS", { type: "tennis" });
      sendEvent("GET_SPORTS", { type: "soccer" });
      if (homeData?.eSoccer === true) {
        sendEvent("GET_SPORTS", { type: "esoccer" });
      }
      if (homeData?.basketBall === true) {
        sendEvent("GET_SPORTS", { type: "basketball" });
      }
    }, 5000);
    setTimeout(() => {
      getInPlayData("play");
      getInPlayData("today");
      getInPlayData("tomorrow");
    }, 3300);
  }, []);

  const handleOneclick = () => {
    setOneClickActive(!oneClickActive);
    setOpenModal(true);
  };
  const handleSetting = async () => {
    setOpenSetting(!OpenSetting);
  };
  const updateSetting = async () => {
    let data = {
      api: USER_API.UPDATE_STACK,
      value: {
        defaultStack: manageStack.defaultStack,
        stack: manageStack.stack,
        highLightsOdds: manageStack.highLightsOdds,
        acceptFancyOdds: manageStack.acceptFancyOdds,
        acceptBookmakerOdds: manageStack.acceptBookmakerOdds,
      },
    };

    await postApi(data)
      .then(function (response) {
        setOpenSetting(false);
        // setSearchData(response.data.data)
      })
      .catch((err) => {
        notifyError(err.response.data.message);
        setOpenSetting(false);
        if (err.response.data.statusCode === 401) {
          // Logout()
          // navigate('/login')
        }
      });
    // setOpenModal(true)
  };
  const handleChange = (e: any) => {
    if (searchEvent.typingTimeout) {
      clearTimeout(searchEvent.typingTimeout);
    }

    setSearchEvent({
      searchText: e.target.value,
      typing: false,
      typingTimeout: setTimeout(function () {
        if (searchEvent.searchText.trim() === "") {
        } else {
          getSeatchData(e.target.value);
        }
      }, 500),
    });
  };
  const getSeatchData = async (VALUE: string = "") => {
    let data = {
      api: USER_API.SEARCH,
      value: {
        search: VALUE,
      },
    };

    await postApi(data)
      .then(function (response) {
        setSearchData(response.data.data);
      })
      .catch((err) => {
        if (err.response.data.statusCode === 401) {
          Logout();
          navigate("/login");
        }
      });
  };

  const closeBetBox = () => {
    dispatch({ type: "SET_BET_HISTORY_SHOW", payload: false });
    if (betHistoryHistoryPushed.current) {
      betHistoryHistoryPushed.current = false;
      window.history.back();
    }
  };

  const onBetHistoryClick = (e?: React.MouseEvent) => {
    e?.preventDefault();
    if (betHistoryShow) {
      closeBetBox();
      return;
    }
    window.history.pushState({ betHistoryOverlay: true }, "");
    betHistoryHistoryPushed.current = true;
    dispatch({ type: "SET_BET_HISTORY_SHOW", payload: true });
  };

  useEffect(() => {
    const onPopState = () => {
      // const refreshProfileAndBalance = () => {
      //   if (cookies.get("skyTokenFront")) {
      //     getBalance();
      //   }
      // };

      // const handleVisibilityChange = () => {
      //   if (document.visibilityState === "visible") {
      //     refreshProfileAndBalance();
      //   }
      // };

      // const handleFocus = () => {
      //   refreshProfileAndBalance();
      // };

      // const handlePageShow = () => {
      //   refreshProfileAndBalance();
      // };

      // const handlePopState = () => {
      if (betHistoryHistoryPushed.current) {
        betHistoryHistoryPushed.current = false;
        dispatch({ type: "SET_BET_HISTORY_SHOW", payload: false });
      }
      // refreshProfileAndBalance();
    };

    window.addEventListener("popstate", onPopState);
    return () => window.removeEventListener("popstate", onPopState);

    // window.addEventListener("popstate", handlePopState);
    // window.addEventListener("focus", handleFocus);
    // window.addEventListener("pageshow", handlePageShow);
    // document.addEventListener("visibilitychange", handleVisibilityChange);

    // return () => {
    //   window.removeEventListener("popstate", handlePopState);
    //   window.removeEventListener("focus", handleFocus);
    //   window.removeEventListener("pageshow", handlePageShow);
    //   document.removeEventListener("visibilitychange", handleVisibilityChange);
    // };
  }, [dispatch]);

  useEffect(() => {
    // Close overlay on route change & refetch profile/balance on any navigation (including same page navigation)
    // Close overlay on route change; do not history.back() here —
    // React Router already moved history, and back would undo that navigation.
    betHistoryHistoryPushed.current = false;
    dispatch({ type: "SET_BET_HISTORY_SHOW", payload: false });
    // if (cookies.get("skyTokenFront")) {
    //   getBalance();
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [location.pathname, location.search, location.key]);
  }, [location.pathname]);

  useEffect(() => {
    return () => {
      betHistoryHistoryPushed.current = false;
      dispatch({ type: "SET_BET_HISTORY_SHOW", payload: false });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getCasinoLink = async (fromMobile: boolean = false) => {
    if (HeaderData?.casinoAccess === false) {
      notifyError("Casino access restricted");
      return;
    }
    if (cookies.get("skyTokenFront")) {
      let data = {
        api: USER_API.CASINO_LOGIN,
        value: {
          id: "loginType",
          isMobileLogin: isMobile ? true : false,
          domain:
            window.location.hostname === "localhost"
              ? "taka365.win"
              : window.location.hostname,
        },
        token: cookies.get("skyTokenFront") ? cookies.get("skyTokenFront") : "",
      };

      await postApi(data)
        .then(function (response) {
          const target = window.innerWidth <= 768 ? "_self" : "_blank";
          window.open(response?.data?.data?.url, target);
        })
        .catch((err) => {
          console.log(err);
          notifyError(err?.response?.data?.message);

          if (err.response.data.statusCode === 401) {
            Logout();
            // notifyError('Pin unsuccess')
            // navigate('/login')
          }
        });
    } else {
      if (fromMobile) {
        window.location.pathname = "/login";
      }
      notifyError("please login first");
    }
  };

  const MY_TV_FLAG = useSelector((e: any) => e.myTv);
  const [liveTv, setLiveTv] = useState(false);
  const setOpenTvFlag = () => {
    console.log("set flag :h: ", MY_TV_FLAG);

    dispatch({ type: "LIVE_TV", payload: !MY_TV_FLAG });
    // setLiveTv(!MY_TV_FLAG);
    console.log("MY_TV_FLAG :h: 11 :: ", MY_TV_FLAG);
  };

  return (
    <>
      {window.innerWidth < 993 && betHistoryShow && (
        <div>
          <BetBox
            isMobile={true}
            betHistoryShow={betHistoryShow}
            setShowBetBox={closeBetBox}
          />
        </div>
      )}

      <header
        className={`header ${getHeaderAccountButtonTextClass(domainDetails)}`.trim()}
        style={getHeaderAccountButtonStyle(domainDetails)}
      >
        <Helmet>
          <title>{domainDetails?.title}</title>
        </Helmet>
        <div className="header_wrp" style={styleObjectGetHeaderSchema(getSiteHeaderSchema(domainDetails))}>
          {window.innerWidth > 768 ? (
            <>
              <div className="header_wrp_l">
                {window.innerWidth > 768 ? (
                  <>
                    <div className="header_wrp_l_logo c">
                      {domainDetails?.logo && <img src={getImageUrl(domainDetails?.logo)} alt="logo" loading="eager" decoding="async" onClick={() => navigate("/")} />}
                    </div>
                  </>
                ) : cookies.get("skyTokenFront") ? (
                  <>
                    {window.location.pathname.split("/").length > 3 && (
                      <a
                        id="openTV"
                        className={`a-open_tv ui-link ${MY_TV_FLAG ? "close_tv" : ""
                          }`}
                        onClick={() => setOpenTvFlag()}
                      >
                        <div />
                      </a>
                    )}
                    <a
                      id="openBetsBtn"
                      className={`a-open_bets ui-link ${window.location.pathname.split("/").length < 3
                        ? "ml-0"
                        : ""
                        }`}
                      style={styleObjectGetBGasColor(
                        domainDetails?.colorSchema, false, true
                      )}
                      onClick={(e) => onBetHistoryClick(e)}
                      href="#"
                    >
                      {/* <img id={domainDetails?.colorSchema === "pink" || domainDetails?.colorSchema === "pinkish-purple" ? "openBetsBtn_pink" : ""} src={transparent} /> */}
                      <svg xmlns="http://www.w3.org/2000/svg" className="dynamic-svg" viewBox="0 0 20 20"><path xmlns="http://www.w3.org/2000/svg" fill={`${getTheme(domainDetails?.colorSchema)?.headerIconColor ? getTheme(domainDetails?.colorSchema)?.headerIconColor : getTheme(domainDetails?.colorSchema)?.backgroundColor}`} fill-rule="nonzero" d="M19.314 6.38c-.41-1.052-.987-2.018-1.708-2.862-1.49-1.75-3.574-2.97-5.94-3.368C11.125.06 10.57 0 10 0c-.57 0-1.124.06-1.667.15-2.365.398-4.447 1.62-5.94 3.367-.72.845-1.297 1.81-1.707 2.863C.25 7.504 0 8.722 0 10c0 1.175.213 2.297.585 3.344.38 1.066.927 2.05 1.62 2.914 1.503 1.868 3.662 3.178 6.128 3.592.543.09 1.098.15 1.667.15.57 0 1.124-.06 1.667-.15 2.466-.414 4.625-1.724 6.127-3.592.694-.864 1.242-1.848 1.62-2.913.373-1.047.586-2.17.586-3.345 0-1.278-.25-2.496-.686-3.62zm-1.173.678l-1.747 1.01c-.332-1.095-.937-2.07-1.735-2.848l1.764-1.02c.746.826 1.333 1.793 1.72 2.858zM15.348 10c0 2.948-2.398 5.347-5.347 5.347-2.95 0-5.347-2.4-5.347-5.347 0-2.948 2.398-5.347 5.347-5.347 2.95 0 5.347 2.4 5.347 5.347zM10 1.333c.57 0 1.127.06 1.667.165v2.04c-.534-.137-1.09-.218-1.667-.218-.576 0-1.133.08-1.667.22V1.497c.54-.106 1.097-.165 1.667-.165zM3.578 4.2l1.765 1.02c-.8.778-1.404 1.753-1.736 2.847L1.86 7.057c.385-1.065.973-2.03 1.718-2.856zm-1.82 8.467l1.775-1.024c.282 1.112.84 2.11 1.604 2.923L3.38 15.58c-.717-.848-1.272-1.834-1.622-2.913zm8.242 6c-.57 0-1.127-.06-1.667-.165v-2.04c.534.137 1.09.218 1.667.218.576 0 1.133-.08 1.667-.22v2.042c-.54.106-1.097.165-1.667.165zm6.62-3.087l-1.757-1.014c.763-.81 1.322-1.81 1.604-2.923l1.775 1.025c-.35 1.078-.905 2.064-1.622 2.912zm-6.003-6.325c1.174.418 1.647.966 1.647 1.862 0 .887-.62 1.644-1.755 1.843v.514c0 .27-.218.488-.485.488s-.483-.218-.483-.488v-.444c-.39-.018-.772-.088-1.098-.187-.332-.1-.526-.448-.44-.787l.005-.017c.035-.145.13-.265.258-.335.13-.07.28-.08.42-.03.328.117.708.2 1.11.2.563 0 .947-.22.947-.618 0-.38-.315-.618-1.045-.867-1.056-.358-1.775-.856-1.775-1.822 0-.877.61-1.564 1.667-1.773v-.458c0-.285.24-.513.53-.486.25.025.436.247.436.5v.375c.347.016.634.062.875.125.315.082.504.406.423.723l-.01.034c-.034.14-.124.258-.248.328s-.27.086-.407.043c-.238-.075-.538-.137-.908-.137-.642 0-.848.28-.848.56 0 .327.344.536 1.183.855z" /></svg>
                      Bets
                    </a>
                  </>
                ) : (
                  <div className="header_wrp_l_logo">
                    {domainDetails && <img src={getImageUrl(getSiteLogo(domainDetails))} alt="logo" loading="eager" decoding="async" onClick={() => window.location.href = "/"} />}

                  </div>
                )}

                <div className="search_box">
                  <svg
                    width="19"
                    height="19"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12.547 11.543H12l-.205-.172a4.539 4.539 0 001.06-2.914A4.442 4.442 0 008.41 4C5.983 4 4 5.989 4 8.457a4.442 4.442 0 004.445 4.457c1.094 0 2.12-.411 2.905-1.062l.206.171v.548L14.974 16 16 14.971l-3.453-3.428zm-4.102 0a3.069 3.069 0 01-3.077-3.086 3.068 3.068 0 013.077-3.086 3.069 3.069 0 013.076 3.086 3.069 3.069 0 01-3.076 3.086z"
                      fill="rgb(30,30,30"
                    ></path>
                  </svg>
                  <input
                    type="text"
                    placeholder="Search Events"
                    onChange={(e) => handleChange(e)}
                  />
                  {searchData && searchEvent.searchText !== "" && (
                    <div className="search-result">
                      <ul
                        id="ui-id-2"
                        className="ui-menu ui-widget ui-widget-content ui-autocomplete ui-front"
                        unselectable="on"
                        style={{
                          top: "52px",
                          left: "167.672px",
                          width: "275.484px",
                        }}
                      >
                        {searchData &&
                          searchData.map((item: any) => (
                            <li className="ui-menu-item">
                              <div
                                id="ui-id-15"
                                className="ui-menu-item-wrapper"
                              >
                                <a
                                  href={`/multimarket/${item.gameId}/${item.marketId}`}
                                >
                                  {item.name}
                                </a>
                              </div>
                            </li>
                          ))}
                      </ul>
                    </div>
                  )}
                </div>
              </div>

              <div
                className={`header_wrp_r ${window.location.pathname.split("/")[1] === "user"
                  ? "user"
                  : ""
                  }`}
              >
                {!isAuthenticated && !cookies.get("skyTokenFront") ? (
                  <>
                    <ul className="login-wrap d_flex ">
                      <li className="user error">
                        <div className="d_flex" style={{ position: "relative" }}>
                          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: "8px", verticalAlign: "middle" }}>
                            <circle cx="12" cy="8" r="4" fill={getTheme(domainDetails?.colorSchema)?.headerTextColor || "#F5A623"} />
                            <path d="M4 20c0-4.4 3.6-8 8-8s8 3.6 8 8" fill={getTheme(domainDetails?.colorSchema)?.headerTextColor || "#F5A623"} />
                          </svg>
                          <input
                            id="loginName"
                            value={formData.user_name}
                            onChange={(e) => handelInputChange(e)}
                            name="user_name"
                            type="text"
                            placeholder="Username"
                            autoComplete="username"
                          />
                        </div>
                        <span className="error" style={{ color: "red" }}>
                          {Validator.current.message(
                            "user_Name",
                            formData.user_name,
                            "required"
                          )}
                        </span>
                      </li>
                      <li>
                        <div style={{ position: "relative" }}>
                          <input
                            id="password"
                            value={formData.password}
                            onChange={(e) => handelInputChange(e)}
                            type={showPass ? "text" : "password"}
                            name="password"
                            placeholder="Password"
                            autoComplete="current-password"
                            style={{ paddingRight: "30px" }}
                          />
                          <span
                            onClick={() => setShowPass(!showPass)}
                            style={{
                              position: "absolute",
                              right: "5px",
                              top: "50%",
                              transform: "translate(0, -50%)",
                            }}
                          >
                            <img
                              style={{ width: "15px", cursor: "pointer" }}
                              src={
                                showPass
                                  ? "./images/eye_close.png"
                                  : "./images/eye.png"
                              }
                              alt=""
                            />
                          </span>
                        </div>
                        <span className="error" style={{ color: "red" }}>
                          {Validator.current.message(
                            "password",
                            formData.password,
                            "required"
                          )}
                        </span>
                      </li>
                      {isCaptcha && (
                        <li className="valid-code">
                          <input
                            id="validCode"
                            type="text"
                            onChange={(e) => handelInputChange(e)}
                            value={formData.validationCode}
                            name="validationCode"
                            placeholder="Validation"
                            maxLength={4}
                          />
                          <h3>{confirmationCode}</h3>
                          {/* <img id="authenticateImage" src="https://bxawscf.skyexchange.com/verifycode.gr?v=1666603469424" /> */}
                        </li>
                      )}
                      <li>
                        <input id="valid" name="valid" type="hidden" value="" />
                      </li>
                      <SignupButton site={domainDetails} />
                      <li>
                        <a
                          id="loginBtn"
                          className="btn-login"
                          onClick={(e) => handelSubmit(e)}
                        >
                          Login
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="10"
                            height="11"
                          >
                            <path
                              d="M5.71 7.706l1.432-1.604H1.778V4.898h5.39L5.71 3.294l.781-.86L9.278 5.5 6.49 8.565l-.78-.86zM1.12 0C.825 0 .564.124.339.372a1.24 1.24 0 0 0-.339.86v8.536c0 .325.113.611.339.86.225.248.486.372.78.372H8.88c.295 0 .556-.124.781-.372a1.24 1.24 0 0 0 .339-.86V7.333H8.88v2.435H1.12V1.232h7.76v2.435H10V1.232a1.24 1.24 0 0 0-.339-.86C9.436.124 9.175 0 8.881 0H1.12z"
                              fill="#FFF"
                              fillRule="evenodd"
                            />
                          </svg>
                        </a>
                      </li>
                    </ul>
                    <ul className="login-wrap d_flex mobile_login ">
                      <SignupButton site={domainDetails} variant="mobile" />
                      <li>
                        {" "}
                        <Link id="loginBtn" to="/login" className={getMobileLoginButtonClassName(DD?.mobileLoginButtonColor)} style={getMobileLoginButtonStyle(DD?.mobileLoginButtonColor)}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            style={{ marginRight: "5px" }}
                            width="17"
                            height="17"
                            viewBox="0 0 17 17"
                          >
                            <path
                              fill="rgb(255,255,255)"
                              fillRule="evenodd"
                              d="M11.797 11.65c2.342.338 4.072 1.702 4.51 2.1C16.74 14.148 17 17 17 17H0s-.03-2.314.744-3.25c.437-.398 1.81-1.762 4.153-2.1 2.326-.322 1.616-2.774 1.696-2.743.08.045-.016-.522-.016-.522S4.88 6.837 4.897 5.442c.032-1.41 0-2.132 0-2.132S5.17 0 7.563 0l1.34.614c2.15 0 2.505 2.696 2.505 2.696v2.33S11.134 7.62 9.792 8.34c0 0-.096.57-.015.52.08-.03-.307 2.47 2.02 2.792z"
                            />
                          </svg>
                          Login
                        </Link>
                      </li>
                    </ul>
                  </>
                ) : (
                  <ul className="account-wrap">
                    <li className="main-wallet">
                      <a
                        id="multiWallet"
                        href="#multiBalancePop"
                        className="a-wallet"
                      >
                        <ul id="accountCredit d_flex">
                          {!isLoadding ? (
                            <>
                              <li
                                style={styleObjectGetBGasColor(
                                  domainDetails?.colorSchema, false, true
                                )}
                              >
                                <span>Main </span>
                                <span
                                  style={{ fontWeight: "bolder" }}
                                  id="betCredit"
                                >
                                  {domainDetails?.currency
                                    ? `${domainDetails?.currency} `
                                    : "PTH "}
                                  {formatTwoDecimal(balanceData)}
                                </span>
                              </li>
                              <li
                                style={styleObjectGetBGasColor(
                                  domainDetails?.colorSchema, false, true
                                )}
                              >
                                <span>Exposure</span>{" "}
                                <span
                                  className={`exposures ${Number(exposureData) > 0 ? "active" : ""
                                    }`}
                                  id="totalExposure"
                                >
                                  {formatTwoDecimal(Math.abs(Number(exposureData)))}
                                </span>
                              </li>
                              {/* <li className="nums">+<span id="vendorQuantity">4</span></li> */}
                            </>
                          ) : (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="100px"
                              height="40px"
                              viewBox="0 0 100 100"
                              preserveAspectRatio="xMidYMid"
                            >
                              <g transform="translate(20 50)">
                                <circle
                                  cx="0"
                                  cy="0"
                                  r="6"
                                  fill={getHeaderAccountButtonTextColor(domainDetails)}
                                >
                                  <animateTransform
                                    attributeName="transform"
                                    type="scale"
                                    begin="-0.375s"
                                    calcMode="spline"
                                    keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
                                    values="0;1;0"
                                    keyTimes="0;0.5;1"
                                    dur="1s"
                                    repeatCount="indefinite"
                                  ></animateTransform>
                                </circle>
                              </g>
                              <g transform="translate(40 50)">
                                <circle
                                  cx="0"
                                  cy="0"
                                  r="6"
                                  fill={getHeaderAccountButtonTextColor(domainDetails)}
                                >
                                  <animateTransform
                                    attributeName="transform"
                                    type="scale"
                                    begin="-0.25s"
                                    calcMode="spline"
                                    keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
                                    values="0;1;0"
                                    keyTimes="0;0.5;1"
                                    dur="1s"
                                    repeatCount="indefinite"
                                  ></animateTransform>
                                </circle>
                              </g>
                              <g transform="translate(60 50)">
                                <circle
                                  cx="0"
                                  cy="0"
                                  r="6"
                                  fill={getHeaderAccountButtonTextColor(domainDetails)}
                                >
                                  <animateTransform
                                    attributeName="transform"
                                    type="scale"
                                    begin="-0.125s"
                                    calcMode="spline"
                                    keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
                                    values="0;1;0"
                                    keyTimes="0;0.5;1"
                                    dur="1s"
                                    repeatCount="indefinite"
                                  ></animateTransform>
                                </circle>
                              </g>
                              <g transform="translate(80 50)">
                                <circle
                                  cx="0"
                                  cy="0"
                                  r="6"
                                  fill={getHeaderAccountButtonTextColor(domainDetails)}
                                >
                                  <animateTransform
                                    attributeName="transform"
                                    type="scale"
                                    begin="0s"
                                    calcMode="spline"
                                    keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
                                    values="0;1;0"
                                    keyTimes="0;0.5;1"
                                    dur="1s"
                                    repeatCount="indefinite"
                                  ></animateTransform>
                                </circle>
                              </g>
                            </svg>
                          )}
                        </ul>
                        <div
                          className="nums"
                          style={styleObjectGetBorderColor(
                            domainDetails?.colorSchema, true, domainDetails?.headerAccountButtonTextColor
                          )}
                        >
                          <span
                            id="vendorQuantity"
                            style={styleObjectGetBGasColor(
                              domainDetails?.colorSchema, false, true
                            )}
                          >
                            +4
                          </span>
                        </div>

                        {/* show wallet */}
                        <div className="wallet-detail" id="multiBalancePop">
                          <div>
                            <div className="wallet-detail-group">
                              <dl className="wallet-detail-content">
                                <dt>Main Balance</dt>
                                <dd className="wallet-balance-num">
                                  <span
                                    className="badge-currency"
                                    id="currency"
                                  >
                                    {domainDetails?.currency
                                      ? domainDetails?.currency
                                      : "PTH"}
                                  </span>
                                  <span id="mainBalance">{formatTwoDecimal(balanceData)}</span>
                                </dd>
                                <dd className="wallet-exposure">
                                  Exposure{" "}
                                  <span id="mainExposure">{formatTwoDecimal(exposureData)}</span>
                                </dd>
                              </dl>
                            </div>
                            <div
                              id="walletContent"
                              className="wallet-detail-group"
                            >
                              <dl id="tempDl" className="wallet-detail-content">
                                <dt id="vendorTitle_1">Casino Balance</dt>
                                <dd className="wallet-balance-num">
                                  <span
                                    className="badge-currency"
                                    id="vendorCurrency_1"
                                  >
                                    PTH
                                  </span>
                                  <span id="vendorBalance_1">0</span>
                                </dd>
                                <dd className="wallet-recall">
                                  <button
                                    className="btn-recall"
                                    id="recall_1"
                                  //  onclick="TopMenuHandler.recall('1')"
                                  >
                                    Recall
                                  </button>
                                </dd>
                              </dl>
                              <dl id="tempDl" className="wallet-detail-content">
                                <dt id="vendorTitle_3">BPoker Balance</dt>
                                <dd className="wallet-balance-num">
                                  <span
                                    className="badge-currency"
                                    id="vendorCurrency_3"
                                  >
                                    PTH
                                  </span>
                                  <span id="vendorBalance_3">0 Points</span>
                                </dd>
                                <dd className="wallet-recall">
                                  <button
                                    className="btn-recall"
                                    id="recall_3"
                                  // onclick="TopMenuHandler.recall('3')"
                                  >
                                    Recall
                                  </button>
                                </dd>
                              </dl>
                              <dl id="tempDl" className="wallet-detail-content">
                                <dt id="vendorTitle_5">SABA Balance</dt>
                                <dd className="wallet-balance-num">
                                  <span
                                    className="badge-currency"
                                    id="vendorCurrency_5"
                                  >
                                    PTH
                                  </span>
                                  <span id="vendorBalance_5">0</span>
                                </dd>
                                <dd className="wallet-recall">
                                  <button
                                    className="btn-recall"
                                    id="recall_5"
                                  // onclick="TopMenuHandler.recall('5')"
                                  >
                                    Recall
                                  </button>
                                </dd>
                              </dl>
                              <dl id="tempDl" className="wallet-detail-content">
                                <dt id="vendorTitle_4">Sky Trader Balance</dt>
                                <dd className="wallet-balance-num">
                                  <span
                                    className="badge-currency"
                                    id="vendorCurrency_4"
                                  >
                                    PTH
                                  </span>
                                  <span id="vendorBalance_4">0</span>
                                </dd>
                                <dd className="wallet-recall">
                                  <button
                                    className="btn-recall"
                                    id="recall_4"
                                  //  onclick="TopMenuHandler.recall('4')"
                                  >
                                    Recall
                                  </button>
                                </dd>
                              </dl>
                              <dl
                                id="recallAllDl"
                                className="wallet-detail-content"
                              >
                                <dd className="text_right">
                                  <button
                                    className="btn-recall"
                                    id="recallAll"
                                  // onclick="TopMenuHandler.recall('1,3,5')"
                                  >
                                    Recall All
                                  </button>
                                </dd>
                              </dl>
                            </div>
                            <div
                              id="walletTemp"
                              className="wallet-detail-group"
                              style={{ display: "none" }}
                            >
                              <dl id="tempDl" className="wallet-detail-content">
                                <dt id="vendorTitle">Housie Balance</dt>
                                <dd className="wallet-balance-num">
                                  <span
                                    className="badge-currency"
                                    id="vendorCurrency"
                                  >
                                    USD
                                  </span>
                                  <span id="vendorBalance">$ 0.00</span>
                                </dd>
                                <dd className="wallet-recall">
                                  <button className="btn-recall" id="recall">
                                    Recall
                                  </button>
                                </dd>
                              </dl>
                              <dl
                                id="recallAllDl"
                                className="wallet-detail-content"
                              >
                                <dd className="text_right">
                                  <button className="btn-recall" id="recallAll">
                                    Recall All
                                  </button>
                                </dd>
                              </dl>
                            </div>
                            <div className="btn-box">
                              <button
                                className="btn"
                                onClick={() =>
                                (window.location.href =
                                  "javascript:history.back();")
                                }
                              >
                                Close
                              </button>
                            </div>
                          </div>
                        </div>

                        <p
                          className="loading-bar"
                          id="menuRefreshLoading"
                          style={{ display: "none" }}
                        >
                          <span></span>
                          <span></span>
                          <span></span>
                          <span></span>
                          <span></span>
                          <span></span>
                          <span></span>
                          <span></span>
                        </p>
                      </a>
                      {/* <a id="menuRefresh" className="a-refresh" onClick={() => window.location.reload()} title="Refresh Main Wallet"> */}
                      <a
                        id="menuRefresh"
                        className={`a-refresh ${domainDetails?.colorSchema === "pink" || domainDetails?.colorSchema === "pinkish-purple" ? "pink" : ""}`}
                        onClick={() => getBalance()}
                        title="Refresh Main Wallet"
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" className="refresh-svg" viewBox="0 0 13 17"><path d="M6.408 3.223c1.164 0 2.238.288 3.223.863.972.563 1.739 1.324 2.302 2.283.588.998.882 2.072.882 3.223 0 1.151-.294 2.225-.882 3.223-.563.972-1.33 1.739-2.302 2.302-.998.588-2.072.882-3.223.882-1.151 0-2.225-.294-3.223-.882-.972-.563-1.739-1.33-2.302-2.302-.588-.998-.882-2.072-.882-3.223h1.612c0 .87.214 1.672.643 2.408.428.735 1.01 1.317 1.746 1.746.735.428 1.538.643 2.408.643.87 0 1.672-.214 2.408-.643.735-.428 1.317-1.01 1.746-1.746.428-.735.643-1.538.643-2.408 0-.87-.214-1.672-.643-2.408-.428-.735-1.01-1.317-1.746-1.746-.735-.428-1.538-.643-2.408-.643v3.223l-4.01-4.01 4.01-4.01v3.223z" fill={`${getTheme(domainDetails?.colorSchema)?.headerIconColor ? getTheme(domainDetails?.colorSchema)?.headerIconColor : getTheme(domainDetails?.colorSchema)?.backgroundColor}`} /></svg>
                      </a>
                    </li>

                    <li className="account">
                      <a
                        id="accountPopup"
                        style={styleObjectGetBGasColor(
                          domainDetails?.colorSchema
                        )}
                        onClick={() => setMenuActive(!menuActive)}
                      >
                        My Account
                      </a>

                      <ul
                        id="account_pop"
                        onClick={() => setMenuActive(!menuActive)}
                        style={{ display: `${menuActive ? "block" : "none"}` }}
                      >
                        <li>
                          <h4>
                            {headerOptions?.user_name}
                            <span className="gmt" title="Time Zone">
                              GMT+5:30
                            </span>
                          </h4>
                        </li>

                        <li>
                          <Link to="/profile" replace={true}>
                            My Profile
                          </Link>
                        </li>
                        <li>
                          <Link to="/user/balance-overview/" replace={true}>
                            Balance Overview
                          </Link>
                        </li>
                        <li>
                          <Link to="/user/account-statement/" replace={true}>
                            Account Statement{" "}
                          </Link>
                        </li>
                        <li>
                          <Link to="/user/mybet/" replace={true}>
                            Current Bets{" "}
                          </Link>
                        </li>
                        <li>
                          <Link to="/user/bethistory/" replace={true}>
                            Bets History{" "}
                          </Link>
                        </li>
                        <li>
                          <Link to="/user/profitloss/" replace={true}>
                            Profit &amp; Loss
                          </Link>
                        </li>
                        <li>
                          <Link to="/user/results/" replace={true}>
                            Results
                          </Link>
                        </li>
                        <li>
                          <Link to="/user/activity-log/" replace={true}>
                            Activity Log{" "}
                          </Link>
                        </li>

                        {/* <li>
                          <Link to={"d-w"} replace={true}>
                            {" "}
                            <b>Deposit/Withdraw wallet</b>{" "}
                          </Link>
                        </li> */}

                        <li className="logout" onClick={(e) => HandleLogOut(e)}>
                          <a id="logout">
                            LOGOUT
                            <span />
                          </a>
                        </li>
                      </ul>
                    </li>

                    <li className="a-setting-div">
                      <a
                        className="a-setting frntStng ui-link"
                        href="#"
                        title="Setting"
                        onClick={() => setOpenSetting(!OpenSetting)}
                      >
                        {/* <img className="img" src={domainDetails?.colorSchema === "pink" || domainDetails?.colorSchema === "pinkish-purple" ? pinkSetingImage : yelloImage} /> */}
                        {/* <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20">
                          <defs>
                            <path d="M0 4.004A3.997 3.997 0 0 1 3.998 0h27.004A3.999 3.999 0 0 1 35 4.004v23.992A3.997 3.997 0 0 1 31.002 32H3.998A3.999 3.999 0 0 1 0 27.996V4.004z" id="b" />
                            <filter x="-2.9%" y="-3.1%" width="105.7%" height="106.3%" filterUnits="objectBoundingBox" id="a">
                              <feOffset dy="2" in="SourceAlpha" result="shadowOffsetInner1" />
                              <feComposite in="shadowOffsetInner1" in2="SourceAlpha" operator="arithmetic" k2="-1" k3="1" result="shadowInnerInner1" />
                              <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0" in="shadowInnerInner1" />
                            </filter>
                          </defs>
                          <g fill="none" style={{ height: "5.06667vw", width: "5.06667vw" }} fill-rule="evenodd">
                            <g transform="translate(-8 -6)">
                              <use fill="#000" filter="url(#a)" />
                              <path stroke="#BC8C17" d="M.5 4.004v23.992A3.499 3.499 0 0 0 3.998 31.5h27.004a3.497 3.497 0 0 0 3.498-3.504V4.004A3.499 3.499 0 0 0 31.002.5H3.998A3.497 3.497 0 0 0 .5 4.004z" stroke-linejoin="square" />
                            </g>
                            <path d="M10.488 13c.621 0 1.203-.16 1.744-.478a3.608 3.608 0 0 0 1.29-1.278A3.32 3.32 0 0 0 14 9.512c0-.621-.16-1.203-.478-1.744a3.578 3.578 0 0 0-1.29-1.29A3.382 3.382 0 0 0 10.488 6a3.32 3.32 0 0 0-1.732.478c-.534.318-.96.748-1.278 1.29A3.382 3.382 0 0 0 7 9.512c0 .621.16 1.198.478 1.732.318.534.744.96 1.278 1.278a3.32 3.32 0 0 0 1.732.478zm7.187-2.014l2.147 1.634c.099.08.157.184.173.313a.555.555 0 0 1-.074.36l-2.073 3.462a.448.448 0 0 1-.26.216.56.56 0 0 1-.357-.024l-2.542-.985c-.658.464-1.242.793-1.752.985l-.37 2.62a.607.607 0 0 1-.185.313.453.453 0 0 1-.309.12H7.927a.485.485 0 0 1-.469-.433l-.395-2.62c-.69-.272-1.267-.6-1.727-.985l-2.567.985c-.263.112-.469.048-.617-.192L.079 13.293a.555.555 0 0 1-.074-.36.464.464 0 0 1 .173-.313l2.171-1.634A7.323 7.323 0 0 1 2.3 10c0-.433.017-.761.05-.986L.177 7.38a.464.464 0 0 1-.173-.313.555.555 0 0 1 .074-.36l2.073-3.462c.148-.24.354-.304.617-.192l2.567.985a8.02 8.02 0 0 1 1.727-.985l.395-2.62A.485.485 0 0 1 7.927 0h4.146c.115 0 .218.04.309.12.09.08.152.184.185.313l.37 2.62c.641.24 1.226.569 1.752.985l2.542-.985a.56.56 0 0 1 .358-.024.448.448 0 0 1 .259.216l2.073 3.462c.066.112.09.232.074.36a.464.464 0 0 1-.173.313l-2.147 1.634c.033.225.05.553.05.986 0 .433-.017.761-.05.986z" fill={`${getTheme(domainDetails?.colorSchema)?.backgroundColor}`} />
                          </g>
                        </svg> */}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                          style={{ height: "5.06667vw", width: "5.06667vw" }}
                          fill="none"
                        >
                          <defs>
                            <path
                              id="rounded-box"
                              d="M0 4.004A3.997 3.997 0 0 1 3.998 0h27.004A3.999 3.999 0 0 1 35 4.004v23.992A3.997 3.997 0 0 1 31.002 32H3.998A3.999 3.999 0 0 1 0 27.996V4.004z"
                            />

                            <filter
                              id="inner-shadow"
                              x="-2.9%"
                              y="-3.1%"
                              width="105.7%"
                              height="106.3%"
                              filterUnits="objectBoundingBox"
                            >
                              <feOffset
                                dy="2"
                                in="SourceAlpha"
                                result="shadowOffset"
                              />

                              <feComposite
                                in="shadowOffset"
                                in2="SourceAlpha"
                                operator="arithmetic"
                                k2="-1"
                                k3="1"
                                result="innerShadow"
                              />

                              <feColorMatrix
                                in="innerShadow"
                                values="
          0 0 0 0 1
          0 0 0 0 1
          0 0 0 0 1
          0 0 0 0.5 0
        "
                              />
                            </filter>
                          </defs>
                          <g transform="translate(-8 -6)">
                            <use
                              href="#rounded-box"
                              fill="#000000"
                              filter="url(#inner-shadow)"
                            />

                            <path
                              d="M.5 4.004v23.992A3.499 3.499 0 0 0 3.998 31.5h27.004a3.497 3.497 0 0 0 3.498-3.504V4.004A3.499 3.499 0 0 0 31.002.5H3.998A3.497 3.497 0 0 0 .5 4.004z"
                              stroke="#BC8C17"
                              stroke-linejoin="square"
                            />
                          </g>
                          <path
                            d="M10.488 13c.621 0 1.203-.16 1.744-.478a3.608 3.608 0 0 0 1.29-1.278A3.32 3.32 0 0 0 14 9.512c0-.621-.16-1.203-.478-1.744a3.578 3.578 0 0 0-1.29-1.29A3.382 3.382 0 0 0 10.488 6a3.32 3.32 0 0 0-1.732.478c-.534.318-.96.748-1.278 1.29A3.382 3.382 0 0 0 7 9.512c0 .621.16 1.198.478 1.732.318.534.744.96 1.278 1.278a3.32 3.32 0 0 0 1.732.478zm7.187-2.014l2.147 1.634c.099.08.157.184.173.313a.555.555 0 0 1-.074.36l-2.073 3.462a.448.448 0 0 1-.26.216.56.56 0 0 1-.357-.024l-2.542-.985c-.658.464-1.242.793-1.752.985l-.37 2.62a.607.607 0 0 1-.185.313.453.453 0 0 1-.309.12H7.927a.485.485 0 0 1-.469-.433l-.395-2.62c-.69-.272-1.267-.6-1.727-.985l-2.567.985c-.263.112-.469.048-.617-.192L.079 13.293a.555.555 0 0 1-.074-.36.464.464 0 0 1 .173-.313l2.171-1.634A7.323 7.323 0 0 1 2.3 10c0-.433.017-.761.05-.986L.177 7.38a.464.464 0 0 1-.173-.313.555.555 0 0 1 .074-.36l2.073-3.462c.148-.24.354-.304.617-.192l2.567.985a8.02 8.02 0 0 1 1.727-.985l.395-2.62A.485.485 0 0 1 7.927 0h4.146c.115 0 .218.04.309.12.09.08.152.184.185.313l.37 2.62c.641.24 1.226.569 1.752.985l2.542-.985a.56.56 0 0 1 .358-.024.448.448 0 0 1 .259.216l2.073 3.462c.066.112.09.232.074.36a.464.464 0 0 1-.173.313l-2.147 1.634c.033.225.05.553.05.986 0 .433-.017.761-.05.986z"
                            fill={`${getTheme(domainDetails?.colorSchema)?.headerIconColor ? getTheme(domainDetails?.colorSchema)?.headerIconColor : getTheme(domainDetails?.colorSchema)?.backgroundColor}`}
                          />
                        </svg>
                      </a>
                      <StakePopup
                        setOpenSetting={setOpenSetting}
                        OpenSetting={OpenSetting}
                      />
                    </li>
                  </ul>
                )}
              </div>
            </>
          ) : (
            <div
              className={`header_wrp_r ${window.location.pathname.split("/")[1] === "user" ? "user" : ""
                }`}
            >
              {/* {
                                cookies.get('skyTokenFront') ?
                                    <>
                                        {window.location.pathname.split('/').length > 3 &&
                                            <a id="openTV" className={`a-open_tv ui-link ${liveTv ? 'close_tv' : ''}`} onClick={() => setLiveTv(!liveTv)}>
                                                <div />
                                            </a>
                                        }
                                        <a id="openBetsBtn" className={`a-open_bets ui-link ${window.location.pathname.split('/').length < 3 ? 'ml-0' : ''}`} style={styleObjectGetBGasColor(domainDetails?.colorSchema)} onClick={() => onBetHistoryClick()} href="#"><img src={transparent} />Bets</a>

                                    </>
                                    :
                                    <div className="header_wrp_l_logo">
                                        <img src={getImageUrl(domainDetails?.logo)} alt="logo" />
                                    </div>
                            } */}
              {!isAuthenticated && !cookies.get("skyTokenFront") ? (
                <>
                  <div className="header_wrp_l_logo">
                    {domainDetails && <img src={getImageUrl(getSiteLogo(domainDetails))} alt="logo" loading="eager" decoding="async" onClick={() => window.location.href = "/"} />}
                  </div>
                  <ul className="login-wrap d_flex ">
                    <li className="user error">
                      <input
                        id="loginName"
                        value={formData.user_name}
                        onChange={(e) => handelInputChange(e)}
                        name="user_name"
                        type="text"
                        placeholder="Username"
                        autoComplete="username"
                      />
                      <span className="error" style={{ color: "red" }}>
                        {Validator.current.message(
                          "user_Name",
                          formData.user_name,
                          "required"
                        )}
                      </span>
                    </li>
                    <li>
                      <div style={{ position: "relative" }}>
                        <input
                          id="password"
                          value={formData.password}
                          onChange={(e) => handelInputChange(e)}
                          type={showPass ? "text" : "password"}
                          name="password"
                          placeholder="Password"
                          autoComplete="current-password"
                          style={{ paddingRight: "30px" }}
                        />
                        <span
                          onClick={() => setShowPass(!showPass)}
                          style={{
                            position: "absolute",
                            right: "5px",
                            top: "50%",
                            transform: "translate(0, -50%)",
                          }}
                        >
                          <img
                            style={{ width: "15px", cursor: "pointer" }}
                            src={
                              showPass
                                ? "./images/eye_close.png"
                                : "./images/eye.png"
                            }
                            alt=""
                          />
                        </span>
                      </div>
                      <span className="error" style={{ color: "red" }}>
                        {Validator.current.message(
                          "password",
                          formData.password,
                          "required"
                        )}
                      </span>
                    </li>
                    {isCaptcha && (
                      <li className="valid-code">
                        <input
                          id="validCode"
                          type="text"
                          onChange={(e) => handelInputChange(e)}
                          value={formData.validationCode}
                          name="validationCode"
                          placeholder="Validation"
                          maxLength={4}
                        />
                        <h3>{confirmationCode}</h3>
                        {/* <img id="authenticateImage" src="https://bxawscf.skyexchange.com/verifycode.gr?v=1666603469424" /> */}
                      </li>
                    )}
                    <li>
                      <input id="valid" name="valid" type="hidden" value="" />
                    </li>
                    <SignupButton site={domainDetails} />
                    <li>
                      <a
                        id="loginBtn"
                        className="btn-login"
                        onClick={(e) => handelSubmit(e)}
                      >
                        Login
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="10"
                          height="11"
                        >
                          <path
                            d="M5.71 7.706l1.432-1.604H1.778V4.898h5.39L5.71 3.294l.781-.86L9.278 5.5 6.49 8.565l-.78-.86zM1.12 0C.825 0 .564.124.339.372a1.24 1.24 0 0 0-.339.86v8.536c0 .325.113.611.339.86.225.248.486.372.78.372H8.88c.295 0 .556-.124.781-.372a1.24 1.24 0 0 0 .339-.86V7.333H8.88v2.435H1.12V1.232h7.76v2.435H10V1.232a1.24 1.24 0 0 0-.339-.86C9.436.124 9.175 0 8.881 0H1.12z"
                            fill="#FFF"
                            fillRule="evenodd"
                          />
                        </svg>
                      </a>
                    </li>
                  </ul>
                  <ul className="login-wrap d_flex mobile_login ">
                    <SignupButton site={domainDetails} variant="mobile" />
                    <li>
                      {" "}
                      <Link id="loginBtn" to="/login" className={getMobileLoginButtonClassName(DD?.mobileLoginButtonColor)} style={getMobileLoginButtonStyle(DD?.mobileLoginButtonColor)}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          style={{ marginRight: "5px" }}
                          width="17"
                          height="17"
                          viewBox="0 0 17 17"
                        >
                          <path
                            fill="rgb(255,255,255)"
                            fillRule="evenodd"
                            d="M11.797 11.65c2.342.338 4.072 1.702 4.51 2.1C16.74 14.148 17 17 17 17H0s-.03-2.314.744-3.25c.437-.398 1.81-1.762 4.153-2.1 2.326-.322 1.616-2.774 1.696-2.743.08.045-.016-.522-.016-.522S4.88 6.837 4.897 5.442c.032-1.41 0-2.132 0-2.132S5.17 0 7.563 0l1.34.614c2.15 0 2.505 2.696 2.505 2.696v2.33S11.134 7.62 9.792 8.34c0 0-.096.57-.015.52.08-.03-.307 2.47 2.02 2.792z"
                          />
                        </svg>
                        Login
                      </Link>
                    </li>
                  </ul>
                </>
              ) : (
                <ul className="account-wrap">
                  <li className="tv_bets" >
                    {window.location.pathname.split("/").length > 3 &&
                      window.location.pathname.split("/")[1] ===
                      "multimarket" && (
                        <a
                          id="openTV"
                          className={`a-open_tv ui-link ${MY_TV_FLAG ? "close_tv" : ""
                            }`}
                          onClick={() => setOpenTvFlag()}
                        >
                          <div />
                        </a>
                      )}
                    <a
                      id="openBetsBtn"
                      className={`a-open_bets ui-link ${window.location.pathname.split("/").length < 3
                        ? "ml-0"
                        : ""
                        }`}
                      style={styleObjectGetBGasColor(
                        domainDetails?.colorSchema, false, true
                      )}
                      onClick={(e) => onBetHistoryClick(e)}
                      href="#"
                    >
                      {/* <img id={domainDetails?.colorSchema === "yellow-yellow" ? "openBetsBtn_white" : domainDetails?.colorSchema === "pink" || domainDetails?.colorSchema === "pinkish-purple" ? "openBetsBtn_pink" : ""} src={transparent} /> */}
                      <svg xmlns="http://www.w3.org/2000/svg" className="dynamic-svg" viewBox="0 0 20 20"><path xmlns="http://www.w3.org/2000/svg" fill={`${getTheme(domainDetails?.colorSchema)?.headerIconColor ? getTheme(domainDetails?.colorSchema)?.headerIconColor : getTheme(domainDetails?.colorSchema)?.backgroundColor}`} fill-rule="nonzero" d="M19.314 6.38c-.41-1.052-.987-2.018-1.708-2.862-1.49-1.75-3.574-2.97-5.94-3.368C11.125.06 10.57 0 10 0c-.57 0-1.124.06-1.667.15-2.365.398-4.447 1.62-5.94 3.367-.72.845-1.297 1.81-1.707 2.863C.25 7.504 0 8.722 0 10c0 1.175.213 2.297.585 3.344.38 1.066.927 2.05 1.62 2.914 1.503 1.868 3.662 3.178 6.128 3.592.543.09 1.098.15 1.667.15.57 0 1.124-.06 1.667-.15 2.466-.414 4.625-1.724 6.127-3.592.694-.864 1.242-1.848 1.62-2.913.373-1.047.586-2.17.586-3.345 0-1.278-.25-2.496-.686-3.62zm-1.173.678l-1.747 1.01c-.332-1.095-.937-2.07-1.735-2.848l1.764-1.02c.746.826 1.333 1.793 1.72 2.858zM15.348 10c0 2.948-2.398 5.347-5.347 5.347-2.95 0-5.347-2.4-5.347-5.347 0-2.948 2.398-5.347 5.347-5.347 2.95 0 5.347 2.4 5.347 5.347zM10 1.333c.57 0 1.127.06 1.667.165v2.04c-.534-.137-1.09-.218-1.667-.218-.576 0-1.133.08-1.667.22V1.497c.54-.106 1.097-.165 1.667-.165zM3.578 4.2l1.765 1.02c-.8.778-1.404 1.753-1.736 2.847L1.86 7.057c.385-1.065.973-2.03 1.718-2.856zm-1.82 8.467l1.775-1.024c.282 1.112.84 2.11 1.604 2.923L3.38 15.58c-.717-.848-1.272-1.834-1.622-2.913zm8.242 6c-.57 0-1.127-.06-1.667-.165v-2.04c.534.137 1.09.218 1.667.218.576 0 1.133-.08 1.667-.22v2.042c-.54.106-1.097.165-1.667.165zm6.62-3.087l-1.757-1.014c.763-.81 1.322-1.81 1.604-2.923l1.775 1.025c-.35 1.078-.905 2.064-1.622 2.912zm-6.003-6.325c1.174.418 1.647.966 1.647 1.862 0 .887-.62 1.644-1.755 1.843v.514c0 .27-.218.488-.485.488s-.483-.218-.483-.488v-.444c-.39-.018-.772-.088-1.098-.187-.332-.1-.526-.448-.44-.787l.005-.017c.035-.145.13-.265.258-.335.13-.07.28-.08.42-.03.328.117.708.2 1.11.2.563 0 .947-.22.947-.618 0-.38-.315-.618-1.045-.867-1.056-.358-1.775-.856-1.775-1.822 0-.877.61-1.564 1.667-1.773v-.458c0-.285.24-.513.53-.486.25.025.436.247.436.5v.375c.347.016.634.062.875.125.315.082.504.406.423.723l-.01.034c-.034.14-.124.258-.248.328s-.27.086-.407.043c-.238-.075-.538-.137-.908-.137-.642 0-.848.28-.848.56 0 .327.344.536 1.183.855z" /></svg>
                      <span>Bets</span>
                    </a>
                  </li>
                  <li className="main-wallet">
                    <a
                      id="multiWallet"
                      href="#multiBalancePop"
                      className="a-wallet"
                    >
                      <ul id="accountCredit d_flex">
                        {!isLoadding ? (
                          <>
                            <li
                              style={styleObjectGetBGasColor(
                                domainDetails?.colorSchema, false, true
                              )}
                            >
                              <span>Main </span>
                              <span
                                style={{ fontWeight: "bolder" }}
                                id="betCredit"
                              >
                                {domainDetails?.currency
                                  ? `${domainDetails?.currency} `
                                  : "PTH "}
                                {formatTwoDecimal(balanceData)}
                              </span>
                            </li>
                            <li
                              style={styleObjectGetBGasColor(
                                domainDetails?.colorSchema, false, true
                              )}
                            >
                              <span>Exposure</span>{" "}
                              <span
                                className={`exposures ${Number(exposureData) > 0 ? "active" : ""
                                  }`}
                                id="totalExposure"
                                style={styleObjectGetBGasColor(
                                  domainDetails?.colorSchema, false, true
                                )}
                              >
                                {formatTwoDecimal(Math.abs(Number(exposureData)))}
                              </span>
                            </li>
                            {/* <li className="nums">+<span id="vendorQuantity">4</span></li> */}
                          </>
                        ) : (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="100px"
                            height="40px"
                            viewBox="0 0 100 100"
                            preserveAspectRatio="xMidYMid"
                          >
                            <g transform="translate(20 50)">
                              <circle
                                cx="0"
                                cy="0"
                                r="6"
                                fill={getHeaderAccountButtonTextColor(domainDetails)}
                              >
                                <animateTransform
                                  attributeName="transform"
                                  type="scale"
                                  begin="-0.375s"
                                  calcMode="spline"
                                  keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
                                  values="0;1;0"
                                  keyTimes="0;0.5;1"
                                  dur="1s"
                                  repeatCount="indefinite"
                                ></animateTransform>
                              </circle>
                            </g>
                            <g transform="translate(40 50)">
                              <circle
                                cx="0"
                                cy="0"
                                r="6"
                                fill={getHeaderAccountButtonTextColor(domainDetails)}
                              >
                                <animateTransform
                                  attributeName="transform"
                                  type="scale"
                                  begin="-0.25s"
                                  calcMode="spline"
                                  keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
                                  values="0;1;0"
                                  keyTimes="0;0.5;1"
                                  dur="1s"
                                  repeatCount="indefinite"
                                ></animateTransform>
                              </circle>
                            </g>
                            <g transform="translate(60 50)">
                              <circle
                                cx="0"
                                cy="0"
                                r="6"
                                fill={getHeaderAccountButtonTextColor(domainDetails)}
                              >
                                <animateTransform
                                  attributeName="transform"
                                  type="scale"
                                  begin="-0.125s"
                                  calcMode="spline"
                                  keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
                                  values="0;1;0"
                                  keyTimes="0;0.5;1"
                                  dur="1s"
                                  repeatCount="indefinite"
                                ></animateTransform>
                              </circle>
                            </g>
                            <g transform="translate(80 50)">
                              <circle
                                cx="0"
                                cy="0"
                                r="6"
                                fill={getHeaderAccountButtonTextColor(domainDetails)}
                              >
                                <animateTransform
                                  attributeName="transform"
                                  type="scale"
                                  begin="0s"
                                  calcMode="spline"
                                  keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
                                  values="0;1;0"
                                  keyTimes="0;0.5;1"
                                  dur="1s"
                                  repeatCount="indefinite"
                                ></animateTransform>
                              </circle>
                            </g>
                          </svg>
                        )}
                      </ul>
                      <div
                        className="nums"
                        style={styleObjectGetBorderColor(
                          domainDetails?.colorSchema, true, domainDetails?.headerAccountButtonTextColor
                        )}
                      >
                        <span
                          id="vendorQuantity"
                          style={styleObjectGetBGasColor(
                            domainDetails?.colorSchema, false, true
                          )}
                        >
                          +4
                        </span>
                      </div>

                      {/* show wallet */}
                      <div className="wallet-detail" id="multiBalancePop">
                        <div>
                          <div className="wallet-detail-group">
                            <dl className="wallet-detail-content">
                              <dt>Main Balance</dt>
                              <dd className="wallet-balance-num">
                                <span className="badge-currency" id="currency">
                                  {domainDetails?.currency
                                    ? domainDetails?.currency
                                    : "PTH"}
                                </span>
                                <span id="mainBalance">{formatTwoDecimal(balanceData)}</span>
                              </dd>
                              <dd className="wallet-exposure">
                                Exposure{" "}
                                <span id="mainExposure">{formatTwoDecimal(exposureData)}</span>
                              </dd>
                            </dl>
                          </div>
                          <div
                            id="walletContent"
                            className="wallet-detail-group"
                          >
                            <dl id="tempDl" className="wallet-detail-content">
                              <dt id="vendorTitle_1">Casino Balance</dt>
                              <dd className="wallet-balance-num">
                                <span
                                  className="badge-currency"
                                  id="vendorCurrency_1"
                                >
                                  PTH
                                </span>
                                <span id="vendorBalance_1">0</span>
                              </dd>
                              <dd className="wallet-recall">
                                <button
                                  className="btn-recall"
                                  id="recall_1"
                                //  onclick="TopMenuHandler.recall('1')"
                                >
                                  Recall
                                </button>
                              </dd>
                            </dl>
                            <dl id="tempDl" className="wallet-detail-content">
                              <dt id="vendorTitle_3">BPoker Balance</dt>
                              <dd className="wallet-balance-num">
                                <span
                                  className="badge-currency"
                                  id="vendorCurrency_3"
                                >
                                  PTH
                                </span>
                                <span id="vendorBalance_3">0 Points</span>
                              </dd>
                              <dd className="wallet-recall">
                                <button
                                  className="btn-recall"
                                  id="recall_3"
                                // onclick="TopMenuHandler.recall('3')"
                                >
                                  Recall
                                </button>
                              </dd>
                            </dl>
                            <dl id="tempDl" className="wallet-detail-content">
                              <dt id="vendorTitle_5">SABA Balance</dt>
                              <dd className="wallet-balance-num">
                                <span
                                  className="badge-currency"
                                  id="vendorCurrency_5"
                                >
                                  PTH
                                </span>
                                <span id="vendorBalance_5">0</span>
                              </dd>
                              <dd className="wallet-recall">
                                <button
                                  className="btn-recall"
                                  id="recall_5"
                                // onclick="TopMenuHandler.recall('5')"
                                >
                                  Recall
                                </button>
                              </dd>
                            </dl>
                            <dl id="tempDl" className="wallet-detail-content">
                              <dt id="vendorTitle_4">Sky Trader Balance</dt>
                              <dd className="wallet-balance-num">
                                <span
                                  className="badge-currency"
                                  id="vendorCurrency_4"
                                >
                                  PTH
                                </span>
                                <span id="vendorBalance_4">0</span>
                              </dd>
                              <dd className="wallet-recall">
                                <button
                                  className="btn-recall"
                                  id="recall_4"
                                //  onclick="TopMenuHandler.recall('4')"
                                >
                                  Recall
                                </button>
                              </dd>
                            </dl>
                            <dl
                              id="recallAllDl"
                              className="wallet-detail-content"
                            >
                              <dd className="text_right">
                                <button
                                  className="btn-recall"
                                  id="recallAll"
                                // onclick="TopMenuHandler.recall('1,3,5')"
                                >
                                  Recall All
                                </button>
                              </dd>
                            </dl>
                          </div>
                          <div
                            id="walletTemp"
                            className="wallet-detail-group"
                            style={{ display: "none" }}
                          >
                            <dl id="tempDl" className="wallet-detail-content">
                              <dt id="vendorTitle">Housie Balance</dt>
                              <dd className="wallet-balance-num">
                                <span
                                  className="badge-currency"
                                  id="vendorCurrency"
                                >
                                  USD
                                </span>
                                <span id="vendorBalance">$ 0.00</span>
                              </dd>
                              <dd className="wallet-recall">
                                <button className="btn-recall" id="recall">
                                  Recall
                                </button>
                              </dd>
                            </dl>
                            <dl
                              id="recallAllDl"
                              className="wallet-detail-content"
                            >
                              <dd className="text_right">
                                <button className="btn-recall" id="recallAll">
                                  Recall All
                                </button>
                              </dd>
                            </dl>
                          </div>
                          <div className="btn-box">
                            <button
                              className="btn"
                              onClick={() =>
                              (window.location.href =
                                "javascript:history.back();")
                              }
                            >
                              Close
                            </button>
                          </div>
                        </div>
                      </div>

                      <p
                        className="loading-bar"
                        id="menuRefreshLoading"
                        style={{ display: "none" }}
                      >
                        <span></span> <span></span> <span></span> <span></span>{" "}
                        <span></span> <span></span> <span></span> <span></span>
                      </p>
                    </a>
                    {/* <a id="menuRefresh" className="a-refresh" onClick={() => window.location.reload()} title="Refresh Main Wallet"> */}
                    <a
                      id="menuRefresh"
                      className={domainDetails?.colorSchema === "yellow-yellow" ? "a-refresh white" : domainDetails?.colorSchema === "pink" || domainDetails?.colorSchema === "pinkish-purple" ? "a-refresh pink" : "a-refresh"}
                      onClick={() => getBalance()}
                      title="Refresh Main Wallet"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" className="refresh-svg" viewBox="0 0 13 17"><path d="M6.408 3.223c1.164 0 2.238.288 3.223.863.972.563 1.739 1.324 2.302 2.283.588.998.882 2.072.882 3.223 0 1.151-.294 2.225-.882 3.223-.563.972-1.33 1.739-2.302 2.302-.998.588-2.072.882-3.223.882-1.151 0-2.225-.294-3.223-.882-.972-.563-1.739-1.33-2.302-2.302-.588-.998-.882-2.072-.882-3.223h1.612c0 .87.214 1.672.643 2.408.428.735 1.01 1.317 1.746 1.746.735.428 1.538.643 2.408.643.87 0 1.672-.214 2.408-.643.735-.428 1.317-1.01 1.746-1.746.428-.735.643-1.538.643-2.408 0-.87-.214-1.672-.643-2.408-.428-.735-1.01-1.317-1.746-1.746-.735-.428-1.538-.643-2.408-.643v3.223l-4.01-4.01 4.01-4.01v3.223z" fill={`${getTheme(domainDetails?.colorSchema)?.headerIconColor ? getTheme(domainDetails?.colorSchema)?.headerIconColor : getTheme(domainDetails?.colorSchema)?.backgroundColor}`} /></svg>
                    </a>
                  </li>

                  <li className="account">
                    <a
                      id="accountPopup"
                      style={styleObjectGetBGasColor(
                        domainDetails?.colorSchema
                      )}
                      onClick={() => setMenuActive(!menuActive)}
                    >
                      My Account
                    </a>

                    <ul
                      id="account_pop"
                      onClick={() => setMenuActive(!menuActive)}
                      style={{ display: `${menuActive ? "block" : "none"}` }}
                    >
                      <li>
                        <h4>
                          {headerOptions?.user_name}
                          <span className="gmt" title="Time Zone">
                            GMT+5:30
                          </span>
                        </h4>
                      </li>

                      <li>
                        <Link to="/profile" replace={true}>
                          My Profile
                        </Link>
                      </li>
                      <li>
                        <Link to="/user/balance-overview/" replace={true}>
                          Balance Overview
                        </Link>
                      </li>
                      <li>
                        <Link to="/user/account-statement/" replace={true}>
                          Account Statement{" "}
                        </Link>
                      </li>
                      <li>
                        <Link to="/user/mybet/" replace={true}>
                          Current Bets{" "}
                        </Link>
                      </li>
                      <li>
                        <Link to="/user/bethistory/" replace={true}>
                          Bets History{" "}
                        </Link>
                      </li>
                      <li>
                        <Link to="/user/profitloss/" replace={true}>
                          Profit &amp; Loss
                        </Link>
                      </li>
                      <li>
                        <Link to="/user/results/" replace={true}>
                          Results
                        </Link>
                      </li>
                      <li>
                        <Link to="/user/activity-log/" replace={true}>
                          Activity Log{" "}
                        </Link>
                      </li>

                      {/* <li>
                        <Link to={"d-w"} replace={true}>
                          {" "}
                          <b>Deposit/Withdraw wallet</b>{" "}
                        </Link>
                      </li> */}

                      <li className="logout" onClick={(e) => HandleLogOut(e)}>
                        <a id="logout">
                          LOGOUT
                          <span />
                        </a>
                      </li>
                    </ul>
                  </li>

                  <li className="a-setting-div">
                    <a
                      className="a-setting frntStng ui-link"
                      href="#"
                      title="Setting"
                      onClick={() => setOpenSetting(!OpenSetting)}
                    >
                      {/* <img className="img" src={domainDetails?.colorSchema === "yellow-yellow" ? whiteSetingImage : domainDetails?.colorSchema === "pink" || domainDetails?.colorSchema === "pinkish-purple" ? pinkSetingImage : yelloImage} /> */}
                      {/* <svg xmlns="http://www.w3.org/2000/svg" style={{ height: "5.06667vw", width: "5.06667vw" }}>
                        <defs>
                          <path d="M0 4.004A3.997 3.997 0 0 1 3.998 0h27.004A3.999 3.999 0 0 1 35 4.004v23.992A3.997 3.997 0 0 1 31.002 32H3.998A3.999 3.999 0 0 1 0 27.996V4.004z" id="b" />
                          <filter x="-2.9%" y="-3.1%" width="105.7%" height="106.3%" filterUnits="objectBoundingBox" id="a">
                            <feOffset dy="2" in="SourceAlpha" result="shadowOffsetInner1" />
                            <feComposite in="shadowOffsetInner1" in2="SourceAlpha" operator="arithmetic" k2="-1" k3="1" result="shadowInnerInner1" />
                            <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0" in="shadowInnerInner1" />
                          </filter>
                        </defs>
                        <g fill="none" fill-rule="evenodd">
                          <g transform="translate(-8 -6)">
                            <use fill="#000" filter="url(#a)" />
                            <path stroke="#BC8C17" d="M.5 4.004v23.992A3.499 3.499 0 0 0 3.998 31.5h27.004a3.497 3.497 0 0 0 3.498-3.504V4.004A3.499 3.499 0 0 0 31.002.5H3.998A3.497 3.497 0 0 0 .5 4.004z" stroke-linejoin="square" />
                          </g>
                          <path d="M10.488 13c.621 0 1.203-.16 1.744-.478a3.608 3.608 0 0 0 1.29-1.278A3.32 3.32 0 0 0 14 9.512c0-.621-.16-1.203-.478-1.744a3.578 3.578 0 0 0-1.29-1.29A3.382 3.382 0 0 0 10.488 6a3.32 3.32 0 0 0-1.732.478c-.534.318-.96.748-1.278 1.29A3.382 3.382 0 0 0 7 9.512c0 .621.16 1.198.478 1.732.318.534.744.96 1.278 1.278a3.32 3.32 0 0 0 1.732.478zm7.187-2.014l2.147 1.634c.099.08.157.184.173.313a.555.555 0 0 1-.074.36l-2.073 3.462a.448.448 0 0 1-.26.216.56.56 0 0 1-.357-.024l-2.542-.985c-.658.464-1.242.793-1.752.985l-.37 2.62a.607.607 0 0 1-.185.313.453.453 0 0 1-.309.12H7.927a.485.485 0 0 1-.469-.433l-.395-2.62c-.69-.272-1.267-.6-1.727-.985l-2.567.985c-.263.112-.469.048-.617-.192L.079 13.293a.555.555 0 0 1-.074-.36.464.464 0 0 1 .173-.313l2.171-1.634A7.323 7.323 0 0 1 2.3 10c0-.433.017-.761.05-.986L.177 7.38a.464.464 0 0 1-.173-.313.555.555 0 0 1 .074-.36l2.073-3.462c.148-.24.354-.304.617-.192l2.567.985a8.02 8.02 0 0 1 1.727-.985l.395-2.62A.485.485 0 0 1 7.927 0h4.146c.115 0 .218.04.309.12.09.08.152.184.185.313l.37 2.62c.641.24 1.226.569 1.752.985l2.542-.985a.56.56 0 0 1 .358-.024.448.448 0 0 1 .259.216l2.073 3.462c.066.112.09.232.074.36a.464.464 0 0 1-.173.313l-2.147 1.634c.033.225.05.553.05.986 0 .433-.017.761-.05.986z" fill={`${getTheme(domainDetails?.colorSchema)?.backgroundColor}`} />
                        </g>
                      </svg> */}

                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        style={{ height: "5.06667vw", width: "5.06667vw" }}
                        fill="none"
                      >
                        <defs>
                          <path
                            id="rounded-box"
                            d="M0 4.004A3.997 3.997 0 0 1 3.998 0h27.004A3.999 3.999 0 0 1 35 4.004v23.992A3.997 3.997 0 0 1 31.002 32H3.998A3.999 3.999 0 0 1 0 27.996V4.004z"
                          />

                          <filter
                            id="inner-shadow"
                            x="-2.9%"
                            y="-3.1%"
                            width="105.7%"
                            height="106.3%"
                            filterUnits="objectBoundingBox"
                          >
                            <feOffset
                              dy="2"
                              in="SourceAlpha"
                              result="shadowOffset"
                            />

                            <feComposite
                              in="shadowOffset"
                              in2="SourceAlpha"
                              operator="arithmetic"
                              k2="-1"
                              k3="1"
                              result="innerShadow"
                            />

                            <feColorMatrix
                              in="innerShadow"
                              values="
          0 0 0 0 1
          0 0 0 0 1
          0 0 0 0 1
          0 0 0 0.5 0
        "
                            />
                          </filter>
                        </defs>
                        <g transform="translate(-8 -6)">
                          <use
                            href="#rounded-box"
                            fill="#000000"
                            filter="url(#inner-shadow)"
                          />

                          <path
                            d="M.5 4.004v23.992A3.499 3.499 0 0 0 3.998 31.5h27.004a3.497 3.497 0 0 0 3.498-3.504V4.004A3.499 3.499 0 0 0 31.002.5H3.998A3.497 3.497 0 0 0 .5 4.004z"
                            stroke="#BC8C17"
                            stroke-linejoin="square"
                          />
                        </g>
                        <path
                          d="M10.488 13c.621 0 1.203-.16 1.744-.478a3.608 3.608 0 0 0 1.29-1.278A3.32 3.32 0 0 0 14 9.512c0-.621-.16-1.203-.478-1.744a3.578 3.578 0 0 0-1.29-1.29A3.382 3.382 0 0 0 10.488 6a3.32 3.32 0 0 0-1.732.478c-.534.318-.96.748-1.278 1.29A3.382 3.382 0 0 0 7 9.512c0 .621.16 1.198.478 1.732.318.534.744.96 1.278 1.278a3.32 3.32 0 0 0 1.732.478zm7.187-2.014l2.147 1.634c.099.08.157.184.173.313a.555.555 0 0 1-.074.36l-2.073 3.462a.448.448 0 0 1-.26.216.56.56 0 0 1-.357-.024l-2.542-.985c-.658.464-1.242.793-1.752.985l-.37 2.62a.607.607 0 0 1-.185.313.453.453 0 0 1-.309.12H7.927a.485.485 0 0 1-.469-.433l-.395-2.62c-.69-.272-1.267-.6-1.727-.985l-2.567.985c-.263.112-.469.048-.617-.192L.079 13.293a.555.555 0 0 1-.074-.36.464.464 0 0 1 .173-.313l2.171-1.634A7.323 7.323 0 0 1 2.3 10c0-.433.017-.761.05-.986L.177 7.38a.464.464 0 0 1-.173-.313.555.555 0 0 1 .074-.36l2.073-3.462c.148-.24.354-.304.617-.192l2.567.985a8.02 8.02 0 0 1 1.727-.985l.395-2.62A.485.485 0 0 1 7.927 0h4.146c.115 0 .218.04.309.12.09.08.152.184.185.313l.37 2.62c.641.24 1.226.569 1.752.985l2.542-.985a.56.56 0 0 1 .358-.024.448.448 0 0 1 .259.216l2.073 3.462c.066.112.09.232.074.36a.464.464 0 0 1-.173.313l-2.147 1.634c.033.225.05.553.05.986 0 .433-.017.761-.05.986z"
                          fill={`${getTheme(domainDetails?.colorSchema)?.headerIconColor ? getTheme(domainDetails?.colorSchema)?.headerIconColor : getTheme(domainDetails?.colorSchema)?.backgroundColor}`}
                        />
                      </svg>

                    </a>
                    <StakePopup
                      setOpenSetting={setOpenSetting}
                      OpenSetting={OpenSetting}
                    />
                  </li>
                </ul>
              )}
            </div>
          )}
        </div>

        <div
          className="menu_part"
          style={styleObjectGetBG(domainDetails?.colorSchema)}
        >
          <ul>
            {headerOption.map((item, i) => {
              if (!item.hasAccess) return false;
              if (item.name === "Casino" && (!cookies.get("skyTokenFront") || headerOptions?.casinoAccess === false))
                return false;
              return (
                <li key={i}>
                  {["Cricket", "Soccer", "Tennis", "E-Soccer", "basketBall"].includes(item.name) ? (
                    <Link
                      style={styleObjectGetColor(domainDetails?.colorSchema)}
                      className={`${item.subOption.length > 0 ? "menu-drop" : ""
                        } ${window.location.pathname === item.link ? "selected" : ""
                        }`}
                      to={item.link}
                    >
                      {item.name}
                      {item.name === "Cricket" && matchCount && (
                        <span id="tagLive" className="tag-live">
                          <strong></strong>
                          {matchCount.cricket}
                        </span>
                      )}
                      {item.name === "Soccer" && matchCount && (
                        <span id="tagLive" className="tag-live">
                          <strong></strong>
                          {matchCount.soccer}
                        </span>
                      )}
                      {item.name === "Tennis" && matchCount && (
                        <span id="tagLive" className="tag-live">
                          <strong></strong>
                          {matchCount.tennis}
                        </span>
                      )}
                      {item.name === "E-Soccer" && (
                        <span id="tagLive" className="tag-live">
                          <strong></strong>{matchCount?.eSoccer}
                        </span>
                      )}
                      {item.name === "Kabaddi" && (
                        <span id="tagLive" className="tag-live">
                          <strong></strong>0
                        </span>
                      )}
                      {item.name === "basketBall" && (
                        <span id="tagLive" className="tag-live">
                          <strong></strong>{matchCount?.basketBall}
                        </span>
                      )}
                    </Link>
                  ) : item.name === "Casino" && cookies.get("skyTokenFront") ? (
                    <a
                      style={styleObjectGetColor(domainDetails?.colorSchema)}
                      className={`${item.subOption.length > 0 ? "menu-drop" : ""
                        } ${window.location.pathname === item.link ? "selected" : ""
                        } ${item.name === "Casino" ? "casino_class" : ""}`}
                      onClick={() => getCasinoLink()}
                    >
                      {item.name}
                      {item.name === "Casino" ? (
                        <img
                          style={{ width: "20px" }}
                          src="/images/card-game.svg"
                        />
                      ) : (
                        ""
                      )}
                    </a>
                  ) : (
                    <Link
                      style={styleObjectGetColor(domainDetails?.colorSchema)}
                      className={`${item.subOption.length > 0 ? "menu-drop" : ""
                        } ${window.location.pathname === item.link ? "selected" : ""
                        }`}
                      to={item.link}
                    >
                      {item.name}
                    </Link>
                  )}
                </li>
              );
            })}
          </ul>

          <ul className="setting-wrap">
            {/* {cookies.get('skyTokenFront') && <li>
                            <Link to={'d-w'}>
                                <b>Deposit/Withdraw wallet</b>
                            </Link>
                        </li>} */}
            <li
              style={styleObjectGetColor(DD?.colorSchema)}
              className="time_zone"
            >
              <span>Time Zone :</span> GMT+6.00
            </li>
            <li>
              <a
                id="oneClickSetting"
                className={`one_click ${oneClickActive ? "active" : ""}`}
                style={styleObjectGetBGasColor(
                  domainDetails?.colorSchema,
                  true
                )}
              >
                {" "}
                <input
                  type="checkbox"
                  name=""
                  id=""
                  style={{ margin: 0 }}
                />{" "}
                One Click Bet{" "}
              </a>
            </li>{" "}
            {/* onClick={() => handleOneclick()} */}
            <li>
              <a
                id="slipSet"
                className="setting"
                onClick={() => handleSetting()}
              >
                Setting <img src="/images/setting.svg" />
              </a>
            </li>
          </ul>
        </div>
        {!isAuthenticated && !cookies.get("skyTokenFront") ? <></> : <NewsLine />}

        <MobileFooter onCasino={getCasinoLink} />
      </header>

      {window.location.pathname.split("/")[1] === "user" && (
        <ForuserPortal>
          <div className="header foruser">
            <div
              className="menu_part"
              style={styleObjectGetBG(domainDetails?.colorSchema)}
            >
              <ul>
                {headerOption.map((item, i) => {
                  if (!item.hasAccess) return false;
                  if (item.name === "Casino" && (!cookies.get("skyTokenFront") || headerOptions?.casinoAccess === false))
                    return false;
                  return (
                    <li key={i}>
                      {["Cricket", "Soccer", "Tennis", "basketBall", "E-Soccer"].includes(item.name) ? (
                        <Link
                          style={styleObjectGetColor(domainDetails?.colorSchema)}
                          className={`${item.subOption.length > 0 ? "menu-drop" : ""
                            } ${window.location.pathname === item.link
                              ? "selected"
                              : ""
                            }`}
                          to={item.link}
                        >
                          {item.name}
                          {item.name === "Cricket" && matchCount && (
                            <span id="tagLive" className="tag-live">
                              <strong></strong>
                              {matchCount.cricket}
                            </span>
                          )}
                          {item.name === "Soccer" && matchCount && (
                            <span id="tagLive" className="tag-live">
                              <strong></strong>
                              {matchCount.soccer}
                            </span>
                          )}
                          {item.name === "Tennis" && matchCount && (
                            <span id="tagLive" className="tag-live">
                              <strong></strong>
                              {matchCount.tennis}
                            </span>
                          )}
                          {item.name === "E-Soccer" && (
                            <span id="tagLive" className="tag-live">
                              <strong></strong>{matchCount?.eSoccer}
                            </span>
                          )}
                          {item.name === "Kabaddi" && (
                            <span id="tagLive" className="tag-live">
                              <strong></strong>0
                            </span>
                          )}
                          {item.name === "basketBall" && (
                            <span id="tagLive" className="tag-live">
                              <strong></strong>{matchCount?.basketBall}
                            </span>
                          )}
                        </Link>
                      ) : item.name === "Casino" &&
                        cookies.get("skyTokenFront") ? (
                        <a
                          style={styleObjectGetColor(domainDetails?.colorSchema)}
                          className={`${item.subOption.length > 0 ? "menu-drop" : ""
                            } ${window.location.pathname === item.link
                              ? "selected"
                              : ""
                            } ${item.name === "Casino" ? "casino_class" : ""}`}
                          onClick={() => getCasinoLink()}
                        >
                          {item.name}
                          {item.name === "Casino" ? (
                            <img
                              style={{ width: "20px" }}
                              src="/images/card-game.svg"
                            />
                          ) : (
                            ""
                          )}
                        </a>
                      ) : (
                        <Link
                          style={styleObjectGetColor(domainDetails?.colorSchema)}
                          className={`${item.subOption.length > 0 ? "menu-drop" : ""
                            } ${window.location.pathname === item.link
                              ? "selected"
                              : ""
                            }`}
                          to={item.link}
                        >
                          {item.name}
                        </Link>
                      )}
                    </li>
                  );
                })}
              </ul>

              <ul className="setting-wrap">
                {/* {cookies.get('skyTokenFront') && <li>
                            <Link to={'d-w'}>
                                <b>Deposit/Withdraw wallet</b>
                            </Link>
                        </li>} */}
                <li
                  style={styleObjectGetColor(DD?.colorSchema)}
                  className="time_zone"
                >
                  <span>Time Zone :</span> GMT+6.00
                </li>
                <li>
                  <a
                    id="oneClickSetting"
                    className={`one_click ${oneClickActive ? "active" : ""}`}
                    style={styleObjectGetBGasColor(
                      domainDetails?.colorSchema,
                      true
                    )}
                  >
                    {" "}
                    <input
                      type="checkbox"
                      name=""
                      id=""
                      style={{ margin: 0 }}
                    />{" "}
                    One Click Bet{" "}
                  </a>
                </li>{" "}
                {/* onClick={() => handleOneclick()} */}
                <li>
                  <a
                    id="slipSet"
                    className="setting"
                    onClick={() => handleSetting()}
                  >
                    Setting <img src="/images/setting.svg" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </ForuserPortal>
      )}

      {OpenModal && (
        <div
          className={`login popup-wrp fade ${OpenModal ? "popup-show " : ""}`}
        >
          <div className="pop">
            <div className="pop-content">
              <div className="pop-head">
                <div
                  className="pop-close"
                  onClick={() => setOpenModal(true)}
                ></div>
              </div>
              <div className="pop-body">
                <Login OpenModal={OpenModal} setOpenModal={setOpenModal} />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;
